import { getClientId } from 'util/client-id';

export const getACHPoolLocationId = () => `${getClientId()}-POOL_ACCOUNT`;
